import { Link } from "@tanstack/react-router";

import { ErrorSurface } from "@/components/error-surfaces/error-surface";
import { Button } from "@/components/ui/button";

// The app's 404 surface, registered as the router's defaultNotFoundComponent
// (router.tsx). Registering it there — rather than per route — is what makes
// it reachable authenticated or not: it renders wherever notFound() is thrown,
// including the authed catch-all (which still fails closed, sending a signed-
// out visitor through login first) and any public route.
//
// The branded chrome-less layout it introduced now lives in ErrorSurface, shared
// with the 403, 500, and app-crash surfaces so the whole set reads as one app.
export function NotFound() {
  return (
    <ErrorSurface
      code="404"
      title="Page not found"
      message="The page you're looking for doesn't exist or was moved."
      actions={
        // Home is `/`, the landing dispatcher — so this button follows the
        // audience's landing path rather than naming a destination itself.
        <Button asChild className="w-full">
          <Link to="/">Go home</Link>
        </Button>
      }
    />
  );
}
